// register component(s) with react habitat
import codeSplit from 'scripts/higher-order-components/codeSplit'

export default {
  SocialsBlock: codeSplit({
    loadComponent: () =>
      import(
        /* webpackChunkName: "SocialsBlock" */
        './index'
      ),
  }),
}
